import React from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import DevIntegration from '@/dev/components/DevIntegration';
import PaymentPage from '@/payment/PaymentPage';
import i18n from '@/lib/config/i18n';
import NotFound from '@/lib/components/NotFound';
import * as Sentry from '@sentry/react';

import './main.scss';
import PaymentPlanPage from './payment/PaymentPlanPage';
import {GlobalContextProvider} from '@/lib/context/global/index.js';

const shouldDisplayPaymentPlanPage = window.location.pathname.includes('pay-over-time');
const shouldShowPaymentPage = window.location.pathname !== '/' && !shouldDisplayPaymentPlanPage;
const shouldShowDevIntegration = !shouldShowPaymentPage && !shouldDisplayPaymentPlanPage && import.meta.env.DEV === true;
const shouldShowNotFound = !shouldShowPaymentPage && !shouldShowDevIntegration && !shouldDisplayPaymentPlanPage;

if (window.weezConfig?.sentry) {
    Sentry.init({
        dsn: window.weezConfig.sentry.dsn,
        environment: window.weezConfig.sentry.environment,
        release: (import.meta.env.REACT_APP_RELEASE || 'NO_RELEASE') + ((import.meta.env.PAYMENT_PAGE ?? false) ? '-PP' : '-lib'),
        integrations: [
            Sentry.browserTracingIntegration(),
        ],
    });
}
/**
 * This is the entry point.
 * Otherwise, LyriaPay is used as a library and so not as a running application.
 */
ReactDOM.render(
    <React.StrictMode>
        <I18nextProvider i18n={i18n}>
            <GlobalContextProvider>
                {shouldDisplayPaymentPlanPage && <PaymentPlanPage />}
                {shouldShowPaymentPage && <PaymentPage />}
                {shouldShowDevIntegration && <DevIntegration />}
                {shouldShowNotFound && <NotFound />}
            </GlobalContextProvider>
        </I18nextProvider>
    </React.StrictMode>,
    document.getElementById('root'),
);
